const View = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M6.99992 2.625C4.08325 2.625 1.59242 4.43917 0.583252 7C1.59242 9.56083 4.08325 11.375 6.99992 11.375C9.91658 11.375 12.4074 9.56083 13.4166 7C12.4074 4.43917 9.91658 2.625 6.99992 2.625ZM6.99992 9.91667C5.38992 9.91667 4.08325 8.61 4.08325 7C4.08325 5.39 5.38992 4.08333 6.99992 4.08333C8.60992 4.08333 9.91658 5.39 9.91658 7C9.91658 8.61 8.60992 9.91667 6.99992 9.91667ZM6.99992 5.25C6.03159 5.25 5.24992 6.03167 5.24992 7C5.24992 7.96833 6.03159 8.75 6.99992 8.75C7.96825 8.75 8.74992 7.96833 8.74992 7C8.74992 6.03167 7.96825 5.25 6.99992 5.25Z"
      fill="#438DED"
    />
  </svg>
);

export default View;
